import { Box, Grid, LinearProgress } from "@mui/material";
import React from "react";
import ProductItem from "../../../../widgets/ProductItem";
import useApiEp from "../../../../hooks/useApiEp";

const ProductsList = ({ user }) => {
  const { data, isLoading } = useApiEp(
    `/user/get-user-products?id=${user.username}`
  );
  if (isLoading) {
    return <LinearProgress />;
  }
  return (
    <Box>
      <Grid container spacing={3}>
        {data?.data?.map((item, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <ProductItem viewMode={true} key={index} product={item} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ProductsList;
